/**
 * Theme adapter: maps custom-fit events onto this theme's side-panel + open-cc.
 */
if (!customElements.get('custom-fit-drawer')) {
  class CustomFitDrawer extends HTMLElement {
    connectedCallback() {
      this.stack = this.querySelector('custom-fit-stack');
      this.sectionId = this.dataset.sectionId;
      this.onOpen = this.open.bind(this);
      this.onRequestClose = this.requestClose.bind(this);
      this.onPanelClose = this.onPanelClose.bind(this);
      this.onSectionSelect = this.onSectionSelect.bind(this);
      this.onSectionDeselect = this.onSectionDeselect.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      document.addEventListener('custom-fit:open', this.onOpen);
      document.addEventListener('custom-fit:request-close', this.onRequestClose);
      document.addEventListener('panel:close', this.onPanelClose);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('custom-fit:open', this.onOpen);
      document.removeEventListener('custom-fit:request-close', this.onRequestClose);
      document.removeEventListener('panel:close', this.onPanelClose);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    isThisSection(event) {
      return event.detail?.sectionId === this.sectionId;
    }

    onSectionSelect(event) {
      if (!this.isThisSection(event)) return;
      this.open({ detail: {}, fromEditor: true });
    }

    onSectionDeselect(event) {
      if (!this.isThisSection(event)) return;
      this.requestClose();
    }

    onBlockSelect(event) {
      if (!this.isThisSection(event) && !this.contains(event.target)) return;
      this.open({
        detail: {},
        target: event.target,
        fromEditor: true,
      });
    }

    selectedFitNode(target, type) {
      if (!target?.matches) return null;
      if (target.matches(`[data-custom-fit="${type}"]`)) return target;
      return target.querySelector(`:scope > [data-custom-fit="${type}"]`);
    }

    open(event) {
      const target = event?.target;
      const fromEditor = event?.fromEditor === true;
      const alreadyOpen = this.classList.contains('active');
      const step = this.selectedFitNode(target, 'step');

      if (step && this.contains(step)) {
        this.stack?.openItem(
          step.closest('[data-custom-fit="flow"], [data-custom-fit="form"]')?.querySelector('.cf-hub-card')
        );
      } else if (!fromEditor || !alreadyOpen) {
        this.stack?.reset();
      }

      this.stack?.setContext(event?.detail);
      document.body.classList.add('open-cc');
      this.classList.add('active');
      if (!fromEditor) this.focus();
    }

    requestClose() {
      document.dispatchEvent(new CustomEvent('panel:close'));
    }

    onPanelClose() {
      requestAnimationFrame(() => {
        if (!this.classList.contains('active')) {
          this.stack?.reset();
        }
      });
    }
  }

  customElements.define('custom-fit-drawer', CustomFitDrawer);
}
